<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <v-card>
      <v-card-title class="text-subtitle-1 grey lighten-2">
        アドレス帳
      </v-card-title>

      <v-card-text class="pt-3">
        送付先を選択してください。
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">送付先</th>
                <th class="text-left">郵便番号</th>
                <th class="text-left">住所</th>
                <th class="text-left">電話番号</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lists" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.zip }}</td>
                <td>{{ item.address }}</td>
                <td>{{ item.tel }}</td>
                <td class="text-center">
                  <!-- 選択ボタン -->
                  <v-btn @click.stop="confirm(item)">
                    選択
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" text @click="dialog = false">
          キャンセル
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddressLists',
  props: {
    lists: Array,
    confirmAction: Function,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    // 決定
    confirm(item) {
      this.confirmAction(item);
      this.dialog = false;
    },
  },
};
</script>
